

class NewsletterSubscribe {
    constructor() {
        this.subscribeButton = document.querySelector('.subscribe__email--submit');
        this.email = document.querySelector('.subscribe__email');
        this.success = document.querySelector('.subscribe__success');

        this.events();
    }

    events() {
        this.subscribeButton.addEventListener('click', this.subscribe);
    }

    subscribe = e => {
        const email = e.target.parentElement.querySelector('.subscribe__email--input').value;
        console.log({
            email: email
        })
        // use fetch to post to the api
        fetch(window.location.href + '/subscribe', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email
            })
        }).then(res => {
            if (res.status === 200) {
                this.email.classList.add('subscribe__email--hide');
                this.success.classList.remove('subscribe__success--hide');
            } else {
                alert('There was an error subscribing to this event. Please try again later.');
            }
        }).catch(err => {
            alert('There was an error subscribing to this event. Please try again later.');
        })
    }
}

export default NewsletterSubscribe;
